var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

import Icon from './wrappers/ReUpIcon';
var FeatureBuilder = require('./FeatureBuilder.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpField = require('./ReUpField.js');
var ReUpText = require('./ReUpText.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var PlatformConstants = require('./constants/PlatformConstants');
var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var PaymentMethodChooserView = require('./PaymentMethodChooserView.js');
var ShadowView = require('./ShadowView.js');
var AddToWalletButton = require('./AddToWalletButton');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton,
  MKIconToggle
} = MK;

import Svg, {
    Path,
    G,
    Circle
} from './wrappers/react-native-svg-wrapper';

var {
  AppRegistry,
  Text,
  View,
  Image,
  TouchableHighlight,
  ScrollView,
  StyleSheet,
  Platform,
} = ReactNative;

var FeedCard = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      didSelect : function(){},
      title : "",
      body1 : "",
      body2 : "",
      icon : "",
      iconColor : "#000",
      bannerColor : "#444",
      rippleColor : "#444",
      cardColor : "rgba(255,255,255,.8)",
      highlightColor : "rgba(255,255,255,1)",
      titleColor : "#000",
      bodyColor : "#000",
      image : "",
      attachments : [],
      media : [],
      picture : "",
      cardType : 0,
      columnData : [],
      cardHeight : function(height) {},
      loginPressed : function(username, password){alert(username + " " + password)},
      registerPressed : function(){ alert("register!") },
      forgotPasswordPressed : function(){alert("need to set forgotPasswordPressed")},
      logoutPressed : function(){alert("need to set logoutSelected")},
      changePasswordPressed : function(){alert("need to set changePasswordPressed")},
      profilePicSelected : function(){alert("need to set profilePicSelected")},
    }
  },

  getInitialState : function()
  {
    return {
      showPassword : false,
      scrollEnabled : false,
      shouldShowRightArrow : true,
      shouldShowLeftArrow : false,
      shouldShowEmailLogin : false,
    }
  },

  componentDidMount : function()
  {
  },

  focus : function()
  {
    if( this._fieldToFocus ) this._fieldToFocus.focus();
  },

  _username : "",
  onUsernameChange : function(username)
  {
    this._username = username;
  },

  _password : "",
  onPasswordChange : function(password)
  {
    this._password = password;
  },

  render: function()
  {
    var appManager = this.props.appManager;
    if( this.props.cardType == 0 ) // default
    {
      var thisThing = this;
      return (
        <MKButton style={[styles.outerContainer, {backgroundColor: this.props.cardColor}]}
          onPress={() => this.props.didSelect()}
          underlayColor={this.props.highlightColor}
          rippleColor={this.props.rippleColor}
          maskBorderRadius={2}
          onLayout={(info) =>
            {
              var layout = info.nativeEvent.layout;
              this.props.cardHeight(layout.height);
            }}>
          <View style={[styles.container]}>
            <View style={[styles.bannerContainer]}>
              <View style={[styles.bannerCircle, {backgroundColor: this.props.bannerColor}]}>
                <Icon name={this.props.icon} size={16} color={this.props.iconColor} style={[styles.bannerIcon, Globals.BANNER_ICON_ADJUSTMENT]} />
              </View>
            </View>
              <View style={styles.contentContainer}>
                {
                  (typeof this.props.title !== 'undefined') && (this.props.title.length > 0) ?
                    <View style={styles.contentTitle}>
                      <ReUpText appManager={appManager} isTitle={true} style={[{color:this.props.titleColor}]}>
                        {this.props.title}
                      </ReUpText>
                    </View>
                  : null
                }
                {
                  (typeof this.props.smallTitle !== 'undefined') && (this.props.smallTitle.length > 0) ?
                    <ReUpText appManager={appManager} style={[styles.contentTitleSmall, {color:this.props.titleColor}]}>
                      {this.props.smallTitle}
                    </ReUpText> : null
                }
                {
                  this.props.body1.length > 0 ?
                  <ReUpText appManager={appManager} style={[styles.contentBody, {color:this.props.bodyColor}]}>
                    {this.props.body1}
                  </ReUpText>
                  :
                  <View />
                }

                {
                  this.props.columnData.map(function(data,index)
                  {
                    return (
                      <View key={JSON.stringify(data)} style={[styles.rowData, index == (thisThing.props.columnData.length-1) ? {paddingBottom:8} : {}]}>
                      {
                        data.map(function(colData, colIndex)
                        {
                          return (<ReUpText key={colData} appManager={appManager} key={colIndex} style={[styles.colData, colIndex == 0 ? {flex:2, color:thisThing.props.bodyColor} : {textAlign:'center', color:thisThing.props.bodyColor}]}>
                            {colData}
                          </ReUpText>)
                        })
                      }
                      </View>
                    )
                  })
                }
                {
                  this.props.attachments.map(function(attachment, index)
                  {
                    if( typeof attachment.media === 'undefined' || typeof attachment.media.image === 'undefined' ) return null;

                      var width = attachment.media.image.width;
                      var height = attachment.media.image.height;
                      if( width <= 0 || height <= 0 ) return null;

                      var aspectRatio = width / height;
                      height = 220;
                      width = height * aspectRatio;
                      return (
                        <Image resizeMode='contain' style={{
                          marginTop:4,
                          marginLeft:-42,
                          marginRight:8,
                          marginBottom:8,
                          height:120,
                          borderBottomLeftRadius:2, borderBottomRightRadius:2}} source={{uri: attachment.media.image.src}} />
                      )
                  })
                }
                {
                  this.props.media.map(function(aMedia, index)
                  {
                    if( typeof aMedia.media_url_https === 'undefined' ) return null;

                      return (
                        <Image resizeMode='contain' style={{
                          marginTop:4,
                          marginLeft:-42,
                          marginRight:8,
                          marginBottom:8,
                          height:120,
                          borderBottomLeftRadius:2, borderBottomRightRadius:2}} source={{uri: aMedia.media_url_https}} />
                      )
                  })
                }
                {
                  this.props.picture.length > 0 ?
                    <Image resizeMode='contain' style={{
                      marginTop:4,
                      marginLeft:-42,
                      marginRight:8,
                      marginBottom:8,
                      height:120,
                      borderBottomLeftRadius:2, borderBottomRightRadius:2}} source={{uri: this.props.picture}} />
                  : null
                }
              </View>
          </View>
        </MKButton>
      )
    }
    else if( this.props.cardType == 1 ) // image
    {
      return (
        <MKButton style={[styles.outerContainer, {backgroundColor: this.props.cardColor}]}
          onPress={() => this.props.didSelect()}
          underlayColor={this.props.highlightColor}
          rippleColor={this.props.rippleColor}
          maskBorderRadius={2}
          onLayout={(info) =>
            {
              var layout = info.nativeEvent.layout;
              this.props.cardHeight(layout.height);
            }}>
          <Image key={this.props.imageName} style={[styles.imageContainer]} source={{uri: this.props.imageName}}>
            <View style={[styles.bannerContainer]}>
              <View style={[styles.bannerCircle, {backgroundColor: this.props.bannerColor}]}>
                <Icon name={this.props.icon} size={16} color={this.props.iconColor} style={[styles.bannerIcon, Globals.BANNER_ICON_ADJUSTMENT]} />
              </View>
            </View>
            <View style={styles.imageFooterContainer}>
              <View style={styles.contentTitle}>
                <ReUpText appManager={appManager} isTitle={true} style={[{color:this.props.titleColor, textAlign:'center', color:'black', marginTop:4,marginBottom:4, margin:4}]} numberOfLines={3}>
                  {this.props.title}
                </ReUpText>
              </View>
            </View>
          </Image>
        </MKButton>
      )
    }
    else if( this.props.cardType == 2 ) // Login
    {
      var feedCard = this;
      var locManager = appManager.getLocalizationManager();
      var forgotPasswordFeature = appManager.getFeatureForName("ForgotPassword");

      var forgotPasswordButton = appManager.getLocalizationManager().localizedStringForKey("FORGOT_PASSWORD_BUTTON");
      var emailPlaceholder = locManager.localizedStringForKey("EMAIL_PLACEHOLDER_ELLIPSIS");
      var passwordPlaceholder = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER_ELLIPSIS");

      var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
      var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
      var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
      var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
      var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
      var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
      var feedFeature = appManager.getFeatureForName("Feed");
      var headerImage = "";
      if( feedFeature && feedFeature.data.headerImage && feedFeature.data.headerImage.trim().length > 0 )
      {
        headerImage = appManager.absoluteResourceForPath(feedFeature.data.name + '/' + feedFeature.data.headerImage);
      }

      var shouldShowEmailAndFacebook = appManager.useFacebookForFeatureName("Login") && !this.state.shouldShowEmailLogin;

      if( shouldShowEmailAndFacebook )
      {
        return (
          <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor}]}>
            <View style={[styles.fullWidthContainer]}>
              {
                headerImage.length > 0 ?<View />
                  // <Image
                  //   style={{width:150, height:44, alignSelf:'center', marginBottom:4}}
                  //   source={{uri: headerImage}}
                  // />
                  :
                  <View />
              }
              <ReUpButton key="fb" appManager={appManager} icon="facebook-official" iconSize={22} iconPaddingLeft={8} buttonColor="#244BA1" buttonTitleColor="white" style={[styles.doneButton, {marginBottom:0}]} text={locManager.localizedStringForKey("CONTINUE_WITH_FACEBOOK_BUTTON", "Continue With Facebook")}
                onPress={this.props.loginFacebookPressed}
                />
              <ShadowView layout={this.state.layout} text={locManager.localizedStringForKey("OR_LABEL")} appManager={appManager}/>
              <ReUpButton key="showemail" appManager={appManager} style={[styles.doneButton]} text={locManager.localizedStringForKey("LOG_IN_WITH_EMAIL", "Log In With Email")}
                onPress={()=>
                {
                  feedCard.setState({shouldShowEmailLogin:true});
                  setTimeout(()=>
                  {
                    feedCard.focus();
                  }, 100)
                }}
                />
              </View>

          </View>
        )
      }

      return (
        <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor}]}>
          <View style={[styles.fullWidthContainer]}>
            {
              headerImage.length > 0 ?<View />
                // <Image
                //   style={{width:150, height:44, alignSelf:'center', marginBottom:4}}
                //   source={{uri: headerImage}}
                // />
                :
                <View />
            }

              <ReUpField
                ref={(a)=>this._fieldToFocus = a}
                appManager={appManager}
                onChangeText={this.onUsernameChange}
                tintColor={this.props.bodyColor}
                highlightColor={this.props.bannerColor}
                textInputStyle={{color: this.props.titleColor}}
                placeholder={emailPlaceholder}
                placeholderTextColor={'grey'}
                autoCapitalize={'none'}
                autoCorrect={false}
                keyboardType={'email-address'}
                returnKeyType={"next"}
                onSubmitEditing={() => this.refs["password"].focus()}/>
              <ReUpField
                ref="password"
                appManager={appManager}
                onChangeText={this.onPasswordChange}
                tintColor={this.props.bodyColor}
                highlightColor={this.props.bannerColor}
                placeholderTextColor={'grey'}
                textInputStyle={{color: this.props.titleColor}}
                placeholder={passwordPlaceholder}
                secureTextEntry={true}
                returnKeyType={"done"}
                onSubmitEditing={() => this.props.loginPressed(feedCard._username, feedCard._password)}/>

                <ReUpButton appManager={appManager} style={styles.loginButton}
                  onPress={() => {
                    this.props.loginPressed(feedCard._username, feedCard._password)
                  }}
                  text={this.props.loginFeatureData.title}
                />
                <ReUpButton appManager={appManager} isSecondary={true} style={[styles.loginButton, {marginTop:8}]}
                  onPress={() => {
                    this.props.forgotPasswordPressed();
                  }}
                  text={forgotPasswordButton}
                />
            </View>

        </View>
      )
    }
    else if( this.props.cardType == 3 ) // settings top card
    {
      var appManager = this.props.appManager;
      var thisThing = this;
      var locMan = appManager.getLocalizationManager();
      var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
      var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

      var loggedInAsName = this.props.loggedInAsName;
      var loggedInAsEmail = this.props.loggedInAsEmail;
      var logoutText = this.props.logoutText;

      var currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
      var currPoints = parseFloat(appManager.currentUser()[ModelConstants.Points]);
      var creditString = appManager.getLocalizationManager().localizedDollars(currDollars);
      var pointsString = appManager.getLocalizationManager().localizedPts(currPoints);

      var classNames = typeof appManager.currentUser()[ModelConstants.ClassNames] !== 'undefined' ? appManager.currentUser()[ModelConstants.ClassNames].join(", ") : "";

      var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
      var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
      var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
      var profileImage = this.props.profileImage;
      var profileColor = appManager.getColorForKey("ProfileColor");
      var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
      var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
      var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
      var profileIconColor = appManager.getColorForKey("ProfileIconColor");
      var profileImageColor = appManager.getColorForKey("ProfileImageColor");
      var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", .2);

      var initials = appManager.currentUserInitials();

      var useSelfie = (typeof this.props.selfieURL !== 'undefined' && this.props.selfieURL != null && this.props.selfieURL.length > 0);

      return (
        <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor, padding: 10}]}>
          <View style={[styles.container,styles.profileContainer]}>
            <View style={styles.profileTopContainer}>
              <View style={[styles.profileImageContainer]}>
                <TouchableHighlight
                  underlayColor={"transparent"}
                  activeOpacity={0.9}
                  onPress={() => {thisThing.props.profilePicSelected()}}>
                  <View style={[styles.profileImage, {borderColor:profileColor, borderWidth:0, backgroundColor:profileColor}]}>
                    {
                      useSelfie ?
                      <View style={{flex: 1}}>
                        <ReUpText appManager={appManager} style={[styles.profileImageText, {position: 'absolute', bottom: 0, right: 0, top:16, left: 0}]}>
                          {initials}
                        </ReUpText>
                        <Image source={{uri: this.props.selfieURL}} style={{backgroundColor:'transparent',margin:0, borderRadius:38, margin:1, flex:1, justifyContent:'center'}}>
                        </Image>
                      </View>
                      :
                      <View style={{flex:1,backgroundColor:profileImageColorLight, borderRadius:39, justifyContent:'center'}}>
                        <View>
                          <ReUpText appManager={appManager} style={[styles.profileImageText, {color:profileImageColor}]}>
                            {initials}
                          </ReUpText>
                        </View>
                        <View style={{position:'absolute', bottom:0, left:0, right:0, height:24, justifyContent:'center', alignItems:'center'}}>
                          <Icon name={"camera"} size={16} color={profileImageColor} />
                        </View>
                      </View>
                    }
                    <Svg
                      height={110}
                      width={110}
                      style={{position:'absolute', top:-10,left:-10, backgroundColor:'transparent'}}
                    >
                        <G scale="1">
                          <Circle cx="50" cy="50" r="39.5" stroke={profileImageColor} stroke-width={2} fill={'transparent'} />
                        </G>
                    </Svg>
                  </View>
                </TouchableHighlight>
              </View>
              <View style={styles.profileInfoContainer}>
                <ReUpText appManager={appManager} isTitle={true} style={{color:this.props.titleColor, marginVertical:4, marginTop: 20}}>
                  {loggedInAsName}
                </ReUpText>
                <ReUpText appManager={appManager} style={{color:this.props.bodyColor}}>
                  {loggedInAsEmail}
                </ReUpText>
                <View style={{flexDirection: 'row', justifyContent: 'flex-start', paddingTop: 20, paddingBottom: classNames.length > 0 ? 10 : 20}}>
                  <View style={{flexDirection: 'row', alignItems: 'center'}}>
                    <Icon name={'dollar'} size={15} color={this.props.bodyColor} />
                    <ReUpText appManager={appManager} style={{color:this.props.bodyColor, marginLeft: 10}}>
                      {creditString}
                    </ReUpText>
                  </View>
                  <View style={{flexDirection: 'row', alignItems: 'center', marginLeft: 20}}>
                    <Icon name={'star'} size={15} color={this.props.bodyColor} />
                    <ReUpText appManager={appManager} style={{color:this.props.bodyColor, marginLeft: 10}}>
                      {pointsString}
                    </ReUpText>
                  </View>
                </View>
                {
                  classNames.length > 0 ?
                    <View style={{flexDirection: 'row', justifyContent: 'flex-start', paddingBottom: 20}}>
                      <View style={{flexDirection: 'row', alignItems: 'center'}}>
                        <Icon name={'trophy'} size={15} color={this.props.bodyColor} />
                        <ReUpText appManager={appManager} style={{color:this.props.bodyColor, marginLeft: 10}}>
                          {classNames}
                        </ReUpText>
                      </View>
                    </View>
                  : null
                }
              </View>
            </View>
            <View style={{alignItems:'center', justifyContent:'center'}}>
              <AddToWalletButton appManager={appManager} />
            </View>
          </View>
        </View>
      )
    }
    else if( this.props.cardType == 4) // login create user
    {
      var thisThing = this;
      var appManager = thisThing.props.appManager;
      var locMan = appManager.getLocalizationManager();

      var createUserButton = locMan.localizedStringForKey("CREATEUSER_CREATE_BUTTON");

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

      return (
        <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor}]}>
          <View style={[styles.fullWidthContainer]}>
            <ReUpText appManager={appManager} isTitle={true} style={[styles.contentTitle, {color:this.props.titleColor, marginTop:-4}]}>
              {this.props.createUserFeatureData.title}
            </ReUpText>
            <ReUpText appManager={appManager} style={[styles.contentBody, {color:this.props.bodyColor}]}>
              {this.props.createUserFeatureData.tip}
            </ReUpText>
            <ReUpButton appManager={appManager} style={[styles.loginButton,{marginTop:-4}]}
              onPress={this.props.registerPressed}
              text={this.props.createUserFeatureData.title}
            />
          </View>
        </View>
      )
    }
    else if( this.props.cardType == 5 ) // payment types
    {
      var thisThing = this;
      var appManager = thisThing.props.appManager;
      var locMan = appManager.getLocalizationManager();

      var createUserButton = locMan.localizedStringForKey("CREATEUSER_CREATE_BUTTON");

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

      return (
        <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor}]}>
          <View style={[styles.fullWidthContainer]}>
            <View style={[styles.contentTitle, {marginTop:-4}]}>
              <ReUpText appManager={appManager} isTitle={true} style={[{color:this.props.titleColor}]}>
                {this.props.paymentTypesFeatureData.title}
              </ReUpText>
            </View>
            <ReUpText appManager={appManager} style={[styles.contentBody, {color:this.props.bodyColor}]}>
              {this.props.paymentTypesFeatureData.tip}
            </ReUpText>
          </View>
          <View style={[{flexDirection:'row', marginTop:-8}]}>
            <PaymentMethodChooserView ref={"paymentMethod"} style={{flex:1, marginTop:0}} appManager={appManager} appActions={this.props.appActions}
              paymentInfo={this.props.paymentInfo} />
          </View>
        </View>
      )
    }
    else if( this.props.cardType == 6 ) // transaction history
    {
      var thisThing = this;
      var appManager = thisThing.props.appManager;
      var locMan = appManager.getLocalizationManager();

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

      return (
        <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor}]}>
          <View style={[styles.fullWidthContainer]}>
            <View style={[styles.contentTitle, {marginTop:-4}]}>
              <ReUpText appManager={appManager} isTitle={true} style={[{color:this.props.titleColor}]}>
                {this.props.transactionHistoryFeatureData.title}
              </ReUpText>
            </View>
            <ReUpText appManager={appManager} style={[styles.contentBody, {color:this.props.bodyColor}]}>
              {this.props.transactionHistoryFeatureData.tip}
            </ReUpText>
          </View>

          <View style={styles.profileBottomContainer}>
            <ReUpButton isSecondary={true} appManager={appManager} style={[styles.logoutButton, {marginTop:0}]}
              onPress={() => {
                thisThing.props.appActions.requestFeatureName("TransactionHistory");
              }}
              text={this.props.transactionHistoryFeatureData.title}
            />
          </View>
        </View>
      )
    }
    else if( this.props.cardType == 7 ) // instagram
    {
      var thisThing = this;
      var appManager = thisThing.props.appManager;
      var locMan = appManager.getLocalizationManager();

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
      var feedCardColor = appManager.getColorForKey("FeedCardColor");
      var highlightColor = this.props.highlightColor;
      var rippleColor = this.props.rippleColor;
      var cardColor = this.props.cardColor;
      var imageURLs = this.props.imageURLs;
      if( imageURLs.length <= 0 ) return <View />

      var didSelect = this.props.didSelect;

      return (
        <View key="instagram" style={[styles.outerContainer, {height:200, borderRadius:2}]}>
          <View key="instagramView">
            <ScrollView key="instagramScrollView" scrollEnabled={this.state.scrollEnabled} alwaysBounceHorizontal={true} bounces={true} contentContainerStyle={{backgroundColor:'transparent', borderRadius:2}} horizontal={true} snapToInterval={200} style={{height:200, flex:1, borderRadius:2, backgroundColor:'transparent'}}>
              {
                imageURLs.map(function(imageURL, index)
                {
                  var style = {height:200, width:200};
                  if( index == 0 )
                  {
                    style.borderTopLeftRadius = 2;
                    style.borderBottomLeftRadius = 2;
                    style.borderRadius = 2;
                  }
                  if( index == (imageURLs.length-1) )
                  {
                    style.borderTopRightRadius = 2;
                    style.borderBottomRightRadius = 2;
                    style.borderRadius = 2;
                  }
                  return (
                    <MKButton key={"button"+imageURL} style={{backgroundColor:feedCardColor, borderRadius:2}}
                      onPress={() => didSelect()}
                      underlayColor={highlightColor}
                      rippleColor={rippleColor}
                      maskBorderRadius={2}
                      onLayout={(info) =>
                        {
                          var layout = info.nativeEvent.layout;
                          this.props.cardHeight(layout.height);
                        }}>
                        <Image key={imageURL} style={style} source={{uri: imageURL}} />
                    </MKButton>
                    );
                })
              }
            </ScrollView>
          </View>
          <View style={[styles.bannerContainer, {marginTop:-200}]}>
            <View style={[styles.bannerCircle, {backgroundColor: this.props.bannerColor}]}>
              <Icon name={this.props.icon} size={18} color={this.props.iconColor} style={[styles.bannerIcon, Globals.BANNER_ICON_ADJUSTMENT]} />
            </View>
          </View>
          {
            this.state.scrollEnabled ? null :
            <View style={{alignSelf:'flex-end', marginRight:8}}>
              <ReUpIconButton iconName={"angle-right"} style={{pointerEvents:'auto', paddingLeft:2, width:30,height:30, backgroundColor:'red', marginTop:30}} appManager={appManager} type={1} onPress={function()
                {
                  thisThing.setState({scrollEnabled:true})
                }} />
            </View>
          }
        </View>
      )
    }
    else if( this.props.cardType == 8 ) // tutorial
    {
      var thisThing = this;
      var appManager = thisThing.props.appManager;
      var locMan = appManager.getLocalizationManager();

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

      return (
        <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor}]}>
          <View style={[styles.fullWidthContainer]}>
            <View style={[styles.contentTitle, {marginTop:-4}]}>
              <ReUpText appManager={appManager} isTitle={true} style={[{color:this.props.titleColor}]}>
                {this.props.tutorialFeatureData.title}
              </ReUpText>
            </View>
            <ReUpText appManager={appManager} style={[styles.contentBody, {color:this.props.bodyColor}]}>
              {this.props.tutorialFeatureData.tip}
            </ReUpText>
          </View>

          <View style={styles.profileBottomContainer}>
            <ReUpButton isSecondary={true} appManager={appManager} style={[styles.logoutButton, {marginTop:0}]}
              onPress={() => {
                thisThing.props.appActions.requestFeatureName("Tutorial", {forceShow:true});
              }}
              text={this.props.tutorialFeatureData.title}
            />
          </View>
        </View>
      )
    }
    else if( this.props.cardType == 9 ) // account info
    {
      var thisThing = this;
      var appManager = thisThing.props.appManager;
      var appActions = thisThing.props.appActions;
      var locMan = appManager.getLocalizationManager();

      var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
      var acccountInfoTitle = locMan.localizedStringForKey("ACCOUNT_INFO_TITLE");

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
      var hasPrimaryPaymentMethod = appManager.userHasPrimaryPaymentMethod();
      var phoneFeature = appManager.getFeatureForName("PhoneNumberVerify");
      var phoneNumber = appManager.currentUser()[ModelConstants.PhoneNumber];
      var showPhoneNumberButton = appManager.currentUser()[ModelConstants.ShowPhoneNumber];
      var hasPhoneNumber = appManager.userHasPhoneNumber();
      var editPhoneNumberButton = locMan.localizedStringForKey("EDIT_PHONE_BUTTON", "Edit Phone Number");
      if( !hasPhoneNumber ) editPhoneNumberButton = locMan.localizedStringForKey("SET_PHONE_BUTTON", "Set Phone Number");

      var user = appManager.currentUser();

      return (
        <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor, padding: 10, paddingTop: 0}]}>
          <View style={[styles.fullWidthContainer]}>
            <View style={styles.contentTitle}>
              <ReUpText appManager={appManager} isTitle={true} style={[{color:this.props.titleColor}]}>
                Account Info
              </ReUpText>
            </View>
          </View>
          <View style={[styles.profileBottomContainer, {padding: 0, margin: 0}]}>
            <PaymentMethodChooserView ref={"paymentMethod"} style={{flex:1, marginTop:0, marginBootom: 0}} appManager={appManager} appActions={this.props.appActions}
            paymentInfo={this.props.paymentInfo} />
          </View>
          {
            (typeof phoneFeature !== 'undefined') && showPhoneNumberButton ?
              <View style={{paddingHorizontal: 8, backgroundColor:'transparent', flexDirection:'row'}}>
                <ReUpButton appManager={appManager} isTertiary={true} icon={'pencil'} style={[styles.logoutButton, {backgroundColor: 'transparent', padding: 0}]} text={editPhoneNumberButton}
                  onPress={()=>
                  {
                    appActions.requestFeatureName("PhoneNumberVerify");
                  }} />
              </View>
            : null
          }
          {
            user[ModelConstants.CanJoinGroups] && user[ModelConstants.JoinedGroupNames].length <= 0 ?
              <View style={[styles.profileBottomContainer, {paddingTop:0, backgroundColor:'transparent'}]}>
                <ReUpButton appManager={appManager} style={{
                  justifyContent:'center',
                  flex:1,
                  paddingHorizontal:10}} text={locMan.localizedStringForKey("JOIN_GROUP_BUTTON", "Join Group")}
                  onPress={this.props.joinGroupPressed} />
              </View>
            : null
          }
          {
            user[ModelConstants.CanJoinGroups] && user[ModelConstants.JoinedGroupNames].length > 0 ?
              <View style={[styles.profileBottomContainer, {paddingTop:10, paddingLeft:14, backgroundColor:'transparent', flexDirection:'row', alignItems:'center', justifyContent:'flex-start'}]}>
                <Icon name={"users"} size={18} color={this.props.titleColor} style={{marginRight:10}} />
                <ReUpText appManager={appManager} style={[{color:this.props.titleColor}]}>
                  {user[ModelConstants.JoinedGroupNames].join(", ")}
                </ReUpText>
              </View>
            : null
          }
          {
            user[ModelConstants.HasPassword] ?
              <View style={[styles.profileBottomContainer, {paddingTop:0, backgroundColor:'transparent'}]}>
                <ReUpButton appManager={appManager} isTertiary={true} icon={'pencil'} iconColor={feedCardColor} style={[styles.logoutButton, {backgroundColor: 'transparent', padding: 0}]} text={locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON")}
                  onPress={this.props.changePasswordPressed} />
              </View>
            : null
          }
          {
            appManager.useFacebookForFeatureName("Settings") ?
              <View style={[styles.profileBottomContainer, {paddingTop:0, backgroundColor:'transparent'}]}>
                <ReUpButton appManager={appManager} isTertiary={true} icon={'angle-right'} iconColor={feedCardColor} style={[styles.logoutButton, {backgroundColor: 'transparent', padding: 0}]}
                  text={user[ModelConstants.HasFacebook] ? locMan.localizedStringForKey("FACEBOOK_CONNECTED", "Facebook Connected") : locMan.localizedStringForKey("CONNECT_FACEBOOK", "Connect Facebook")}
                  onPress={this.props.loginFacebookPressed} />
              </View>
            : null
          }
          <View style={[styles.profileBottomContainer, {paddingTop:0}]}>
            <ReUpButton appManager={appManager} isTertiary={true} icon={'angle-right'} iconColor={feedCardColor} style={[styles.logoutButton, {margin: 0,marginVertical: 0,  backgroundColor: 'transparent', padding: 0, marginTop: -5, marginBottom: -10}]}
              onPress={() => {
                thisThing.props.appActions.requestFeatureName("TransactionHistory");
              }}
              text={this.props.transactionHistoryFeatureData.title}
            />
          </View>
          <View style={styles.profileBottomContainer}>
            <ReUpButton appManager={appManager} isTertiary={true} icon={'angle-right'} iconColor={feedCardColor} style={[styles.logoutButton, {backgroundColor: 'transparent', padding: 0}]} text={locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON")}
              onPress={this.props.changePasswordPressed} />
          </View>
        </View>
      )
    }
    else if( this.props.cardType == 10 ) // help
    {
      var thisThing = this;
      var appManager = thisThing.props.appManager;
      var locMan = appManager.getLocalizationManager();

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

      var tutorialFeature = appManager.getFeatureForName("Tutorial");
      var shouldShowTutorial = typeof tutorialFeature !== 'undefined' && !appManager.disableInterstitial();
      
      return (
        <View style={[styles.outerContainer, {backgroundColor: this.props.cardColor, padding: 10, paddingTop: 0}]}>
          <View style={[styles.fullWidthContainer]}>
            <View style={styles.contentTitle}>
              <ReUpText appManager={appManager} isTitle={true} style={[{color:this.props.titleColor}]}>
                Help
              </ReUpText>
            </View>
          </View>
          {
            shouldShowTutorial ?
              <View style={[styles.profileBottomContainer, {paddingTop: 0, marginBottom: 0}]}>
                <ReUpButton appManager={appManager} isTertiary={true} icon={'angle-right'} style={[styles.logoutButton, {backgroundColor: 'transparent', padding: 0}]} text={tutorialFeature.data.title}
                  onPress={()=>
                  {
                    thisThing.props.appActions.requestFeatureName("Tutorial", {forceShow:true});
                  }} />
              </View>
            : null
          }
          <View style={[styles.profileBottomContainer, {paddingTop: 0, marginBottom: 0}]}>
            <ReUpButton appManager={appManager} style={[styles.logoutButton, {padding: 0}]}
              onPress={() => {
                thisThing.props.appActions.requestFeatureName("Tutorial", {forceShow:true});
              }}
              text={locMan.localizedStringForKey("VIEW_TUTORIAL_BUTTON")}
            />
          </View>
          <View style={[styles.profileBottomContainer]}>
            <ReUpButton appManager={appManager} isTertiary={true} icon={'angle-right'} iconColor={feedCardColor} text={locMan.localizedStringForKey("CONTACT_SUPPORT_BUTTON")}
                onPress={this.props.contactSupport} style={[styles.logoutButton, {backgroundColor: 'transparent', padding: 0, marginTop: -5}]} />
          </View>
        </View>
      )
    }
    else if( this.props.cardType == 11 ) // earn points
    {
      var thisThing = this;
      var appManager = thisThing.props.appManager;
      var locMan = appManager.getLocalizationManager();

      var generalColor = appManager.getColorForKey("GeneralColor");
      var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
      var feedCardColor = appManager.getColorForKey("FeedCardColor");
      var highlightColor = this.props.highlightColor;
      var rippleColor = this.props.rippleColor;
      var cardColor = this.props.cardColor;
      var campaigns = this.props.campaigns;
      if( campaigns.length <= 0 ) return <View />

      return (
        <View key="earnPoints" style={[styles.outerContainer, {height:200, borderRadius:2, flexDirection:'column'}]}>
          <View key="earnPointsView" style={{flexDirection:'row'}}>
            <ScrollView key="earnPointsScrollView" ref="earnPointsScrollView" decelerationRate="fast" scrollEnabled={this.state.scrollEnabled} alwaysBounceHorizontal={true} bounces={true} contentContainerStyle={{backgroundColor:'transparent', borderRadius:2}} horizontal={true} snapToInterval={200} style={{height:200, flex:1, borderRadius:2, backgroundColor:'transparent'}}
              scrollEventThrottle={20}
              onScroll={(info)=>
              {
                var scrollOffsetX = info.nativeEvent.contentOffset.x;
                thisThing._page = Math.round(scrollOffsetX/200);
                var shouldShowRightArrow = thisThing._page < (campaigns.length-1);
                if( shouldShowRightArrow != thisThing.state.shouldShowRightArrow ) thisThing.setState({shouldShowRightArrow:shouldShowRightArrow});

                var shouldShowLeftArrow = thisThing._page > 0;
                if( shouldShowLeftArrow != thisThing.state.shouldShowLeftArrow ) thisThing.setState({shouldShowLeftArrow:shouldShowLeftArrow});
              }}>
              {
                campaigns.map(function(campaign, index)
                {
                  var style = {height:200, width:200, flexDirection:'column', justifyContent:'center', alignItems:'center', padding:8};
                  if( index == 0 )
                  {
                    style.borderTopLeftRadius = 2;
                    style.borderBottomLeftRadius = 2;
                  }
                  if( index == (campaigns.length-1) )
                  {
                    style.borderTopRightRadius = 2;
                    style.borderBottomRightRadius = 2;
                  }
                  var iconColor = thisThing.props.bannerColor;
                  var titleColor = thisThing.props.titleColor;
                  var bodyColor = thisThing.props.bodyColor;
                  style.backgroundColor = cardColor;
                  if( (index % 2) == 1)
                  {
                    iconColor = thisThing.props.iconColor;
                    titleColor = thisThing.props.iconColor;
                    bodyColor = thisThing.props.iconColor;
                    style.backgroundColor = thisThing.props.bannerColor;
                  }
                  return (
                    <MKButton key={"button"+campaign.title} style={{backgroundColor:feedCardColor, borderRadius:2}}
                      onPress={() => campaign.didSelect()}
                      underlayColor={highlightColor}
                      rippleColor={rippleColor}
                      maskBorderRadius={2}
                      onLayout={(info) =>
                      {
                        var layout = info.nativeEvent.layout;
                        this.props.cardHeight(layout.height);
                      }}>
                      <View style={style}>
                        <View style={{marginVertical:0}}>
                        {
                          typeof campaign.iconName !== 'undefined' ?
                            <Icon name={campaign.iconName} size={60} color={iconColor} />
                          : null
                        }
                        {
                          typeof campaign.iconText !== 'undefined' ?
                            <ReUpText isTitle={true} style={{fontSize:36, iconColor}}>
                            {campaign.iconText}
                            </ReUpText>
                          : null
                        }
                        </View>
                        <View style={{marginBottom:4}}>
                          <ReUpText isTitle={true} style={{color:titleColor}}>
                          {campaign.title}
                          </ReUpText>
                        </View>
                        <View>
                          <ReUpText style={{color:bodyColor, textAlign:'center'}}>
                          {campaign.body}
                          </ReUpText>
                        </View>
                      </View>
                    </MKButton>
                    );
                })
              }
            </ScrollView>
          </View>
          <View style={[styles.bannerContainer, {marginTop:-200}]}>
            <View style={[styles.bannerCircle, {backgroundColor: this.props.bannerColor}]}>
              <Icon name={this.props.icon} size={18} color={this.props.iconColor} style={[styles.bannerIcon, Globals.BANNER_ICON_ADJUSTMENT]} />
            </View>
          </View>
          {
            this.state.scrollEnabled ? null :
            <View style={{alignSelf:'flex-end', marginRight:8, flexDirection:'row'}}>
              <View>
              {
                this.state.shouldShowLeftArrow ?
                  <ReUpIconButton iconName={"angle-left"} style={{pointerEvents:'auto', opacity:this.state.shouldShowLeftArrow ? 1 : 0, paddingLeft:2, width:30,height:30, marginTop:30}} appManager={appManager} type={1} onPress={function()
                    {
                      if( thisThing.refs.earnPointsScrollView && thisThing._page > 0 ) thisThing.refs.earnPointsScrollView.scrollTo({x:(thisThing._page-1)*200});
                    }} />
                : null
              }
              </View>
              <View style={{width:10}} />
              <View style={{width:40}}>
              {
                this.state.shouldShowRightArrow ?
                  <ReUpIconButton iconName={"angle-right"} style={{pointerEvents:'auto', paddingLeft:2, width:30,height:30, marginTop:30}} appManager={appManager} type={1} onPress={function()
                    {
                      if( thisThing.refs.earnPointsScrollView && thisThing._page < (campaigns.length-1) ) thisThing.refs.earnPointsScrollView.scrollTo({x:(thisThing._page+1)*200});
                      if( Platform.OS === 'ios' ) thisThing.setState({scrollEnabled:true})
                    }} />
                : null
              }
              </View>
            </View>
          }
        </View>
      )
    }
  }
});

var styles = StyleSheet.create({
  outerContainer: {
    flex: -1,
    marginTop:4,
    marginLeft:4,
    marginRight:4,
    alignItems: 'stretch',
    borderRadius:2,
  },
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch',
    borderRadius:2,
  },
  imageContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch',
    height:220,
    borderRadius:2,
  },

  imageFooterContainer: {
    alignSelf:'flex-end',
    flexDirection:'row',
    backgroundColor: 'rgba(255,255,255,.8)',
    flex:1,
    marginLeft:-50,
    paddingLeft:10,
    paddingRight:10,
    justifyContent:'center',
    alignItems:'center',
  },

  fullWidthContainer: {
    flex: 1,
    padding:10,
    flexDirection: 'column',
  },
  fullWidthTitle: {
    flex:1,
  },
  fullWidthBody: {
    flex:1,
  },
  fullWidthContent: {
    flex:1,
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  textField: {
    flex:1,
    width:-1,
    height:50,
    marginTop:10
  },
  loginButton: {
    marginTop:20
  },

  bannerContainer: {
    flexDirection: 'column',
    width: 46,
    alignItems: 'center',
    borderRadius:2,
    height:46,
    backgroundColor:'transparent'
  },
  bannerCircle: {
    width: 30,
    height:30,
    marginTop:8,
    borderRadius:17,
    alignItems: 'center',
    justifyContent: 'center'
  },
  bannerIcon: {
    backgroundColor:'transparent',
    textAlign:'center',
    lineHeight:18,
    height:18,
    width:30,
    marginTop:-2
  },

  contentContainer: {
    flex: 1,
    flexDirection: 'column',
    borderRadius:2,
    paddingTop:2,
  },
  contentTitle: {
    marginRight:8,
    height:30,
    marginTop:6,
    justifyContent:'center',
    flex:-1,
  },
  contentTitleSmall: {
    marginRight:8,
    marginBottom:6,
    marginTop:14,
    flex:-1,
    opacity:0.9,
  },
  contentBody: {
    marginRight:8,
    paddingBottom:8,
    paddingTop:0,
    flex:-1,
  },

  floatingLabelFont: {
    fontStyle: 'italic',
    fontWeight: '200',
  },

// settings styles

  profileContainer: {
    flexDirection: 'column',
  },
  profileTopContainer: {
    flexDirection: 'row',
    justifyContent:'center',
    alignItems:'center',
  },
  profileBottomContainer: {
    flexDirection: 'row',
    alignItems:'stretch',
    justifyContent:'center',
    padding:8,
  },
  logoutButton:{
    flex:1,
  },
  profileImageContainer: {
    width:100,
    height:100,
  },
  profileInfoContainer: {
    flex:1,
    justifyContent:'center',
    flexDirection:'column'
  },
  profileImage: {
    height:80,
    width:80,
    margin:8,
    borderRadius:40,
    borderWidth:2,
    borderColor:'black',
    justifyContent:'center',
  },
  profileImageText: {
    textAlign:'center',
    fontSize:40,
    fontWeight:'bold',
    backgroundColor:'transparent'
  },
  rowData: {
    flexDirection:'row',
  },
  colData: {
    flex:1,
    paddingBottom:4,
    paddingRight:4
  },
  changePasswordContainer: {
    padding:8,
    flexDirection:'column'
  },

  passwordContainer: {
    flexDirection:'row',
  },
  passwordShowButton: {
    borderRadius:25,
    width:50,
    height:50,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf:'center',
    margin:4
  },
});

module.exports = FeedCard;



// WEBPACK FOOTER //
// ./src/feedCard.js